import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getGetUserPinsQueryKey, updateUserPins } from 'ze-sdk';
export function useSaveUserPins() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data)=>updateUserPins(data),
        onSuccess: async ()=>{
            await queryClient.invalidateQueries({
                queryKey: getGetUserPinsQueryKey()
            });
            const breadcrumbsQueryKeys = queryClient.getQueryCache().findAll().filter((query)=>{
                return query.queryKey[0] === 'userNavigation';
            });
            await Promise.all(breadcrumbsQueryKeys.map(async (item)=>{
                await queryClient.invalidateQueries({
                    queryKey: item.queryKey
                });
            }));
        }
    });
}
